<template>
  <div class="documentos_tudo slot">
    <div class="wrap2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {}
  }
}
</script>

<style scoped>
.wrap2 {
  padding-right: 10%;
  padding-left: 10%;
}

.documentos_tudo {
  max-width: 100rem;
  padding-right: 0px;
  padding-left: 0px;
  padding-top: 0px;
  margin: 0 auto 50px;
}

.documentos_tudo.slot {
  padding-top: 15px;
}

@media (min-width: 1400px) {
  .wrap2 {
    padding-left: 15%;
    padding-right: 15%;
    max-width: 100%;
    margin: 0;
  }
}

@media (max-width: 767px) {
  .wrap2 {
    padding-right: 5%;
    padding-left: 5%;
  }

  .documentos_tudo {
    padding-top: 0;
  }
}
</style>